<template>
  <div>
    <transition name="modal">
      <div class="overlay">
        <div class="modal">
          <span>Sessão Expirada</span>
          <p>Você está inativo por 10 minutos.</p>
          <p>Encerrando sessão em {{ time }} segundos</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { logout } from "../services/loginService";

export default {
  data() {
    return {
      time: 10
    };
  },
  created() {
    let timerId = setInterval(() => {
      this.time -= 1;
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);
      if (this.time < 1) {
        clearInterval(timerId);
        logout();
        location.reload();
      }
    }, 1000);
  }
};
</script>

<style scoped>
.modal {
  width: 500px;
  margin: 0px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px 3px;
  transition: all 0.2s ease-in;
  font-family: Helvetica, Arial, sans-serif;
}
.fadeIn-enter {
  opacity: 0;
}

.fadeIn-leave-active {
  opacity: 0;
  transition: all 0.2s step-end;
}

.fadeIn-enter .modal,
.fadeIn-leave-active.modal {
  transform: scale(1.1);
}
button {
  padding: 7px;
  margin-top: 10px;
  background-color: green;
  color: white;
  font-size: 1.1rem;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #00000094;
  z-index: 999;
  transition: opacity 0.2s ease;
}
</style>